import styles from "./valores-section.module.css";
import valoresImg from "../../../images/_finais/ImagemValores_compress.webp";

const ValoresSection = () => {
  return (
    <section className={styles.valores_section}>
      <div className={styles.valores_div}>
        <img
          className={styles.valores_img}
          src={valoresImg}
          alt="Imagem sobre valores da empresa."
          loading="lazy"
        />
        <div className={styles.valores_texts}>
          <div className={styles.title_div}>
            <h1 className={styles.valores_title}>VALORES</h1>
            <span className={styles.line}></span>
          </div>
          <p className={styles.valores_paragraph}>
            <b>Credibilidade:</b> Compromisso com a precisão e a qualidade das
            informações científicas.
          </p>
          <p className={styles.valores_paragraph}>
            <b>Inovação:</b> Busca constante por métodos e soluções inovadoras
            no campo da RWE.
          </p>
          <p className={styles.valores_paragraph}>
            <b>Transparência:</b> Clareza na comunicação e nos processos.
          </p>
          <p className={styles.valores_paragraph}>
            <b>Excelência:</b> Manter altos padrões de desempenho e dedicação em
            todos os projetos.
          </p>
        </div>
        <img
          className={styles.valores_imgMobile}
          src={valoresImg}
          alt="Imagem sobre valores da empresa."
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default ValoresSection;
